<template>
  <router-view></router-view>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { get } from 'lodash'
export default {
  async mounted() {
    await this.resetPolicies()
  },
  computed: {
    ...mapState('auth', ['role', 'user', 'policies'])
  },
  methods: {
    ...mapActions('auth', ['checkAuthPolices']),
    async resetPolicies() {
      const roleId = get(this.user, 'role.id', '')
      if (typeof roleId === 'string' && roleId.length) await this.checkAuthPolices({ roleId: this.user.role.id })
    }
  }
}
</script>
<style>
input {
  margin: 0px 0px !important;
}

.cursor-pointer {
  cursor: pointer;
}

.left-amber-border {
  border-left: 4px solid #0d47a1;
}

.required label::after {
  content: ' *';
  color: red;
}

.v-data-table-header {
  background-color: #f5f5f5;
  border-bottom: none;
}

.content-text {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #757575;
}

.search-button {
  background: white;
  height: 40px !important;
  color: #0d47a1 !important;
}

.tab-active {
  color: #0d47a1 !important;
  background-color: #ffffff !important;
  border: 1px solid lightgrey;
}

.tab-default {
  color: #000;
  background-color: lightgrey;
}

.full-height {
  height: 100% !important;
}

.full-width {
  width: 100% !important;
}
</style>
